// apps/hub/src/main.tsx
import { tryAutoRefresh } from '@neuroforge/shared/client'
import { ThemeProvider, ToastContainer } from '@neuroforge/ui'
import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@neuroforge/ui/theme/globals.css'
import './index.css'
import App from './App'

// Sentry
const sentryDsn = import.meta.env.VITE_SENTRY_DSN_HUB
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: true,
  })
} else if (import.meta.env.DEV) {
  console.info('[sentry] disabled (no VITE_SENTRY_DSN_HUB)')
}

// Auto-refresh cross-app auth (shared refresh cookie)
tryAutoRefresh()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 2 * 60 * 1000, // 2 min global default
    },
    mutations: {
      retry: 0,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
        <ToastContainer />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
